export var boxShadows = {
    /**
     * - Switches
     */
    500: 'rgba(0, 0, 0, 0.24)',
    /**
     * - Dropdown list
     */
    400: 'rgba(0, 0, 0, 0.16)',
    /**
     * - Filters
     * - Payment allocations
     * - Tooltip
     */
    300: 'rgba(0, 0, 0, 0.1)',
};
//# sourceMappingURL=boxShadows.js.map